import { render, staticRenderFns } from "./SaleNoteConcepts.vue?vue&type=template&id=07b8cfba&scoped=true&"
import script from "./SaleNoteConcepts.vue?vue&type=script&lang=js&"
export * from "./SaleNoteConcepts.vue?vue&type=script&lang=js&"
import style0 from "./SaleNoteConcepts.vue?vue&type=style&index=0&id=07b8cfba&scoped=true&lang=css&"
import style1 from "./SaleNoteConcepts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8cfba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b8cfba')) {
      api.createRecord('07b8cfba', component.options)
    } else {
      api.reload('07b8cfba', component.options)
    }
    module.hot.accept("./SaleNoteConcepts.vue?vue&type=template&id=07b8cfba&scoped=true&", function () {
      api.rerender('07b8cfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewSaleNote/SaleNoteConcepts.vue"
export default component.exports